import React from 'react';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import PropTypes from 'prop-types';
import TableHeading from './TableHeading';
import TableItem from './TableItem';
import AppTableContainer from '../../../../@crema/core/AppTableContainer';

const CustomerTable = ({customers, deleteCustomer, domainMapping = {}}) => {
  // Filter out api_key from headings
  const getFilteredHeadings = () => {
    if (customers.length === 0) return [];
    const allKeys = Object.keys(customers[0]);
    return allKeys.filter(key => key !== 'api_key');
  };

  return (
    <AppTableContainer>
      <Table stickyHeader className='table'>
        <TableHead>
          <TableHeading
            headings={getFilteredHeadings()}
          />
        </TableHead>
        <TableBody>
          {customers.map((data) => (
            <TableItem
              data={data}
              key={data.id}
              deleteCustomer={deleteCustomer}
              domainMapping={domainMapping}
            />
          ))}
        </TableBody>
      </Table>
    </AppTableContainer>
  );
};

export default CustomerTable;

CustomerTable.defaultProps = {
  customers: [],
  domainMapping: {},
};

CustomerTable.propTypes = {
  customers: PropTypes.array,
  deleteCustomer: PropTypes.func.isRequired,
  domainMapping: PropTypes.object,
};
